<!--
 * @Author: 高苏杭
 * @Date: 2023-12-12 10:10:51
 * @LastEditTime: 2023-12-12 10:26:44
 * @FilePath: \tjk\src\components\TableTextareaCell\TableTextareaCell.vue
 * @Description: 公共的表格显示文本组件，超过2行显示...，鼠标悬浮显示全部
-->
<template>
  <div
    v-if="value"
    v-html="value.replace(/\n/g, '</br>')"
    :title="value"
    class="table_textarea_cell"
    style="-webkit-box-orient: vertical"
  ></div>
</template>
  <script>
export default {
  name: "TableTextareaCell",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>
  <style lang='scss' scoped>
.table_textarea_cell {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/TableTextareaCell/TableTextareaCell.vue